<template>
    <Modal ref="modal" class="customer-information-modal" size="large">
        <template #body="sp">
            <PreparationCustomerOrderCustomerInformation
                :order="order"
                :info-modal="true"
            />
        </template>
        <template #footer>
            <button class="btn btn-secondary" @click="closeModal()">
                Fermer
            </button>
        </template>
    </Modal>
</template>

<script>
    import Modal from "../../Modal"
    import PreparationCustomerOrderCustomerInformation from "../PreparationCustomerOrderCustomerInformation"

    export default {
        name: 'CustomerInformationModal',

        components: {
            Modal,
            PreparationCustomerOrderCustomerInformation,
        },

        props: {
            order: {
                type: Object,
                required: true,
            },
        },

        methods: {
            showModal() {
                this.$refs.modal.showModal();
            },

            closeModal() {
                this.$refs.modal.closeModal();
            },
        },

        computed: {
            customerTypeLabel() {
                return this.order.customer.type === 'store' ? 'Magasin' : 'Client';
            },
        },
    }
</script>

<style lang="scss">
    .customer-information-modal {
        :first-of-type(.modal-container) {
            max-width: 600px;
            width: auto;
        }
    }
</style>
